export const CDN_URL = process.env.CDN_URL || '';

export const getPluginUrl = (name: string) =>
  `${CDN_URL}/player-plugin-${name}-latest.js`;
export const getSkinUrl = (name: string) =>
  `${CDN_URL}/player-skin-${name}-latest.css`;
export const getDnaUrl = (brand: string) =>
  `${CDN_URL}/player-dna-${brand}-latest.css`;
